/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import type Subject from 'linced-admin/models/goals/subject';
import type Milestone from 'linced-admin/models/milestones/milestone';
import type Set from 'linced-admin/models/milestones/set';
import type Page from 'linced-admin/models/posts/page';

// Proto: milestones.ExpectationTemplate.
export default class Expectation extends Model {
  declare [Type]: 'milestones/expectation';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @belongsTo('goals/subject', { async: true, inverse: null })
  declare goalSubjectTemplateId: AsyncBelongsTo<Subject>;

  @alias('goalSubjectTemplateId')
  declare goalSubjectTemplate: AsyncBelongsTo<Subject>;

  @belongsTo('posts/page', { async: true, inverse: null })
  declare pageTemplateId: AsyncBelongsTo<Page>;

  @alias('pageTemplateId')
  declare pageTemplate: AsyncBelongsTo<Page>;

  @belongsTo('milestones/milestone', { async: true, inverse: null })
  declare milestoneTemplateId: AsyncBelongsTo<Milestone>;

  @alias('milestoneTemplateId')
  declare milestoneTemplate: AsyncBelongsTo<Milestone>;

  @alias('milestoneTemplate.id')
  declare milestone_template_id: string | null | undefined;

  @attr('number', { defaultValue: 0 })
  declare belowIndex: number;

  @attr('number', { defaultValue: 0 })
  declare atIndex: number;

  @attr('number', { defaultValue: 0 })
  declare aboveIndex: number;

  @attr('number', { defaultValue: 0 })
  declare wellAboveIndex: number;

  @belongsTo('milestones/set', { async: true, inverse: 'expectations' })
  declare templateSetId: AsyncBelongsTo<Set>;

  @alias('templateSetId')
  declare templateSet: AsyncBelongsTo<Set>;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;
}
